import SectionCategoryVideo from './SectionCategoryVideo';
export default SectionCategoryVideo;
